import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  FlexDirection,
  Heading2,
  Heading3,
  JustifyContent,
  Space,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { CtaLink, mapCmsCta } from '../../cta'
import type { CmsCtaIntentHandlers } from '../../cta'
import { ContentstackImage } from '../ContentstackImage'

import type { StepsWithImageFields } from './types'

export type StepsWithImageProps = StepsWithImageFields & {
  ctaIntentHandlers?: CmsCtaIntentHandlers
}

export function StepsWithImage({
  heading,
  items = [],
  cta,
  ctaIntentHandlers,
}: StepsWithImageProps) {
  const ctaLink = mapCmsCta(cta, ctaIntentHandlers)

  return (
    <Box paddingH={[8, 20]} paddingV={16} bg={Color.NeutralGrey_50}>
      <Box maxWidth="1200px" style={{ margin: '0 auto' }}>
        <Heading2 textAlign={[TextAlign.Left, null, null, TextAlign.Center]}>{heading}</Heading2>
        <Space size={4} />
        <Box
          display={Display.Flex}
          alignItems={[AlignItems.Center, AlignItems.FlexStart]}
          justifyContent={[
            JustifyContent.Center,
            JustifyContent.SpaceBetween,
            null,
            JustifyContent.SpaceEvenly,
          ]}
          flexDirection={[FlexDirection.Column, FlexDirection.Row]}
          wrap
        >
          {items.map((item) => (
            <Box
              key={item.title}
              display={Display.Flex}
              flexDirection={FlexDirection.Column}
              paddingH={1}
              paddingV={2}
              width={['100%', '50%', null, '170px']}
            >
              <ContentstackImage
                style={{ borderRadius: '8px' }}
                height={['200px', null, null, 'auto']}
                fit="cover"
                alt={item.image_alt ?? ''}
                src={item.image.url}
                sizes="(max-width: 767px) 100vw, (max-width: 1023px) 50vw, 170px"
              />
              <Space size={3} />
              <Heading3 size={6}>{item.title}</Heading3>
              {item.description && <Body2 size={4}>{item.description}</Body2>}
              <Space size={2} />
            </Box>
          ))}
        </Box>
        {ctaLink && (
          <>
            <Space size={6} />
            <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
              <CtaLink cta={ctaLink} />
            </Box>
          </>
        )}
      </Box>
    </Box>
  )
}
